import styled from 'styled-components';
import { Button } from '@interstate/components/Button';
import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';

export const DealCommentsWrapper = styled.div`
    position: relative;
    display: inline-flex;
    align-items: center;

    .ids-status-indicator-dot {
        top: 9px;
        right: 9px;
    }

    @media (max-width: ${BreakPoints.PHONE}) {
        position: static;
    }
`;

export const StyledDealCommentsButton = styled(Button)`
    color: ${({ theme }) => theme.uiBricks?.modalBackgroundColor || '#ffffff'} !important;

    &:hover,
    &:focus,
    &:active {
        color: ${({ theme }) => theme.uiBricks?.modalBackgroundColor || '#ffffff'} !important;
        background-color: transparent !important;
    }
`;

export const DealCommentsPanel = styled.div`
    position: absolute;
    top: calc(100% + 4px);
    right: 7px;
    width: 380px;
    max-width: calc(100vw - 16px);
    z-index: 1300;

    @media (max-width: ${BreakPoints.PHONE}) {
        left: 8px;
        right: 8px;
        width: auto;
        max-width: none;
    }
`;
